export const environment = {
  production: false,
  api: {
    // baseUrl: 'http://localhost:3000',
    baseUrl: 'https://social-api-dev.shoutugc.com',
  },
  tiktok: {
    clientKey: 'sbawzb8a4unn94t06q', // --> Social Connect
    clientSecret: 'rarZd3CoXCMdQMnm6R8MT3M2gYQiqLyq', // --> Social Connect
    redirectUri: 'https://connect-dev.shoutugc.com/tiktok/auth/callback/'
  },
  instagram: {
    clientId: '501616409435499',
    redirectUri: 'https://connect.shoutugc.com/instagram-callback',
    // app_id: '501616409435499',
    ig_app_secret: '2a35e43a888e172954c50b9cf958b32c'
  },
  fbinstagram: {
    clientId: '783668520102368',
    redirectUri: 'https://connect-dev.shoutugc.com/fb-instagram-callback',
  },
  youtube: {
    api_key: 'AIzaSyCOLvKwWEExt4BBM5z5p7VdJRjXdwvZ8ro'
  },
  default: {
    businessId: '4cdf1156-f12a-49d7-b6b8-d6c40d2638a0'
  }
};

// https://connect-dev.shoutugc.com/connect/${userId}/4cdf1156-f12a-49d7-b6b8-d6c40d2638a0
// https://connect-dev.shoutugc.com/connect/u1rbFc22tJfzMilBb59Dv7zEpKj2/4cdf1156-f12a-49d7-b6b8-d6c40d2638a0 -> Neville Longbottom
// https://connect-dev.shoutugc.com/connect/Ouv5a2dgMWPzQshS3AvKLRXdAzV2/4cdf1156-f12a-49d7-b6b8-d6c40d2638a0 -> Mister Beast
// https://connect-dev.shoutugc.com/connect/SFaXnTSAvNNNTEi6Xh7XY5Aqxpq1/4cdf1156-f12a-49d7-b6b8-d6c40d2638a0 -> Jolly Tots

// https://www.instagram.com/accounts/onetap/?
// next=https%3A%2F%2Fwww.instagram.com%2Foauth%2Fauthorize%2F
// third_party%2F%3F
// redirect_uri%3Dhttps%253A%252F%252Fconnect.shoutugc.com%252Finstagram-callback%26
// response_type%3Dcode%26
// scope%3Dinstagram_business_basic%252Cinstagram_business_manage_messages%252Cinstagram_business_manage_comments%252Cinstagram_business_content_publish%252Cinstagram_business_manage_insights%26
// client_id%3D501616409435499%26
// force_reauth%3D0%26
// logger_id%3D8cf734db-0f5d-453c-9964-a43b0e1f2826
